export default __webpack_public_path__ + "60f20120c88053295873284e25d09a5b.png";